import { makeStyles } from '@material-ui/core';

export const useCardTableStyles = makeStyles((theme) => ({
  section: {
    marginTop: 20,
    [theme.breakpoints.down('sm')]: {
      overflowX: 'auto',
    },
    '& h2': {
      fontSize: 24,
      fontWeight: 500,
      margin: 0,
    },
  },
  table: {
    tableLayout: 'auto',
    width: '100%',
    '& .MuiTableCell-root': {
      border: 'none',
      padding: '12px 0 12px 12px',
      wordBreak: 'break-word',
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
        padding: '8px 0 8px 8px',
      }
    },
    '& .MuiTableCell-head': {
      fontSize: 12,
      textTransform: 'uppercase',
      color: theme.palette.gray.g10,
      padding: '12px 6px 0 12px',
      [theme.breakpoints.down('xs')]: {
        fontSize: 10,
        padding: '8px 4px 0 8px',
      },
    },
    '& .MuiTableBody-root .MuiTableRow-root': {
      backgroundColor: theme.palette.gray.g7,
      borderCollapse: 'separate',
      borderSpacing: '0 1em',
    },
    '& .MuiTableBody-root .MuiTableRow-root > td': {
      color: 'black',
      paddingRight: 6,
    },
    '& .MuiTableBody-root .MuiTableRow-root > td:nth-child(1)': {
      borderRadius: '6px 0 0 6px',
    },
    '& .MuiTableBody-root .MuiTableRow-root > td:nth-last-child(1)': {
      borderRadius: '0 6px 6px 0',
    },
    '& .MuiTableCell-body': {
      fontWeight: 500,
    },
    '& .MuiTableBody-root .MuiTableRow-root:nth-last-child(1) > td': {
      border: 'none',
    },
  },
  spacer: {
    height: 6,
  },
  datePill: {
    backgroundColor: theme.palette.gray.g9,
    display: 'inline-block',
    height: 30,
    borderRadius: 15,
    textAlign: 'center' as const,
    lineHeight: '30px',
    paddingInline: 12,
  },
  roundPill: {
    backgroundColor: theme.palette.red.opacity.r16,
    display: 'inline-block',
    whiteSpace: 'nowrap' as const,
    fontSize: 12,
    padding: '6px 10px',
    borderRadius: 24,
    [theme.breakpoints.down('xs')]: {
      fontSize: 10,
      padding: '4px 8px',
      borderRadius: 20,
    },
  },
}));
